import { useCallback } from "react";
import { EVENT_BUS_EVENTS } from "../util/useEventBus";

export const CTA_EVENT_TYPE = {
  GENERIC: "generic",
  ARTICLE_SUBSCRIPTION: "article-subscription",
};

export const CTA_TRIGGER_ACTION = {
  TOPIC_VIEW: "topic view",
  BOOKMARK_ICON_CLICK: "bookmark icon click",
  FOLLOW_ICON_CLICK: "follow icon click",
  IMAGE_CLICK: "image click",
  VIDEO_CLICK: "video click",
  ALGORITHM_CLICK: "algorithm click",
  TABLE_CLICK: "table click",
  CHECK_INTERACTIONS_CLICK: "check interactions click",
  BOXED_WARNING_CLICK: "boxed warning click",
  MERATIVE_LINK_CLICK: "merative link click",
};

export const useLaunchCTA = ({ eventBus }) => {
  const launchCTA = useCallback(
    ({ userAction, type = CTA_EVENT_TYPE.GENERIC }) => {
      eventBus.emit(EVENT_BUS_EVENTS.LAUNCH_CTA, null, {
        type,
        originator: {
          mfe: "content",
          component: "ContentPage",
          userAction,
        },
      });
    },
    [eventBus]
  );

  return { launchCTA };
};
